import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Spinner from '../../../../UI/Spinner/Spinner'
import styles from './TemplateTabs.module.scss'
import { removeUnderscoreAndCapitalize } from '../../../../helpers/vacancyTemplatesManager.helper'
const TemplateTabs = ({ templates, value, handleChange, loading }) => {

    const AntTabs = withStyles({
        root: {
            borderBottom: '1px solid #DFF0EB',
        },
        indicator: {
            backgroundColor: '#94CEBE',
        },
    })(Tabs)

    const AntTab = withStyles((theme) => ({
        root: {
            textTransform: 'none',
            minWidth: 72,
            fontWeight: theme.typography.fontWeightRegular,
            marginRight: theme.spacing(4),
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            color: '#06251E',
            '&:hover': {
                color: '#94CEBE',
                opacity: 1,
            },
            '&$selected': {
                color: '#94CEBE',
                fontWeight: theme.typography.fontWeightMedium,
            },
            '&:focus': {
                color: '#94CEBE',
            },
        },
        selected: {},
    }))((props) => <Tab disableRipple {...props} />);

    return <div className={styles.tabs_wrapper}>
        {loading ?
            (<div className={styles.spinner_wrapper}><Spinner/></div>) : (
                <AntTabs value={value} onChange={handleChange} aria-label="ant example">
            {templates.map((template) => (
                    <AntTab key={template.id} label={removeUnderscoreAndCapitalize(template.name)} />
                    ))}
                </AntTabs>
            )}
    </div>
}

export default TemplateTabs